export class ControllerInfoUx
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    ShowCurrentDialPosition: boolean;
    ShowModeSwitch: boolean;
    ShowSoilSensors: boolean;
    ShowRainSensor: boolean;
    ShowWeatherSensor: boolean;
    ShowSensorState: boolean;
    ShowLastUpdated: boolean;
}
